import { NotificationRepository } from "../domain/NotificationRepository";

export class MarkAsReadNotificationCommand {
  constructor(
    private readonly noti_repo: NotificationRepository,
  ) {}

  run(user_id,noti_id): Promise<{ [key: string]: string; }> {
    return this.noti_repo.mark_as_read(user_id,noti_id);
  }
}